import useQueryParam from '@hooks/use-query-param';

export const useCardId = (): string | undefined => {
    const id = useQueryParam('cid');

    if (typeof id !== 'string' || id.length === 0) {
        return undefined;
    }

    return id;
};
